import type { ReactElement } from 'react';
import { weekAndMonthDay } from 'utils/dateTimes';

import useNotifications from 'hooks/useNotifications';

import Banner from 'components/shared/Banner';

function AddressUpdatedBanner(): ReactElement {
  const { notifications } = useNotifications();
  const { date, address, operation } = notifications.addressChange;

  switch (operation) {
    case 'ADD':
      return (
        <Banner.Success isCentered>
          <div className="u-text--center">
            All set! Your address has been added.
          </div>
        </Banner.Success>
      );

    case 'REMOVE':
      return (
        <Banner.Success isCentered>
          <div className="u-text--center">
            All set! Your address has been removed.
          </div>
        </Banner.Success>
      );

    case 'UPDATE':
      return (
        <Banner.Success isCentered>
          <div className="u-text--center">
            {address ? (
              <>
                {date ? (
                  <>
                    {`All set! On ${weekAndMonthDay(date)} `}
                    your box will be sent to:
                  </>
                ) : (
                  'All set! Your box will be sent to:'
                )}

                {` ${address.firstLine}, `}
                {address.secondLine && `${address.secondLine}, `}
                {`${address.lastLine}. `}

                <br />
              </>
            ) : (
              'All set! Your address has been updated.'
            )}
          </div>
        </Banner.Success>
      );
  }
}

export default AddressUpdatedBanner;
